export const RMA_MANAGER_USER = 'RMA Manager (User)';
export const RMA_MANAGER_MANAGER = 'RMA Manager (Manager)';
export const QUOTE = 'Quote';
export const ORDER_MANAGER = 'Order Manager';
export const CHECKOUT = 'Checkout';
